/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 이미지 목록을 카드형태로 변환하는 툴을 정의한다.
 *
 * @file /src/rootin/blocks/images/tools/Card.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 19.
 */
import { List } from './List';
import { Language, LanguageText } from '@utils/Language';

export class Card extends List {
    /**
     * 툴타입
     */
    static type: string = 'card';

    /**
     * 툴아이콘
     */
    icon: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gallery-horizontal-end-icon lucide-gallery-horizontal-end"><path d="M22 7v10"/><path d="M18 5v14"/><rect width="12" height="18" x="2" y="3" rx="2"/></svg>';

    /**
     * 툴팁
     */
    text: LanguageText = Language.get('rootin.blocks.images.tools.card');
}
